export default "__VITE_ASSET__B2f90Cvg__"